/**
 *
 * MapPage
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import withRest from 'containers/Rest/withRest';
import withClubs from 'containers/Clubs/withEntity';
import withLocations from 'containers/Locations/withEntity';
import withRoutes from 'containers/Routes/withEntity';
import withUser from 'containers/User/withUser';

import Map from 'components/Map';
import RoutesManager from 'components/RoutesManager';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import { DAEMON } from 'utils/constants';
import { Track } from 'utils/analytics';
import EditService from 'containers/EditService';

import makeSelectMapPage from './selectors';
import reducer from './reducer';
import saga from './saga';
import { mapMoved, mapChangedType, mapChangedMode } from './actions';

/* eslint-disable react/prefer-stateless-function */
export class MapPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { mapPage } = this.props;
    Track.event({
      category: 'Map',
      action: 'Type',
      label: mapPage.mapType,
      nonInteraction: true,
    });
  }

  handleChange(ev) {
    const { dispatch } = this.props;
    switch (ev.type) {
      case 'zoomend':
        break;
      case 'moveend':
        dispatch(mapMoved(ev.target));
        break;
      case 'baselayerchange':
        dispatch(mapChangedType(ev.layer));
        break;
      default:
        dispatch(mapChangedMode(ev));
        break;
    }
  }

  render() {
    const { mapPage, match, location, user } = this.props;
    return (
      <React.Fragment>
        <EditService>
          <Map
            onChange={this.handleChange}
            {...mapPage}
            params={match.params}
            location={location}
          />
        </EditService>
        {window.location.hash === '#routes' &&
          user &&
          user.api && <RoutesManager />}
      </React.Fragment>
    );
  }
}

MapPage.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  mapPage: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  mapPage: makeSelectMapPage(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'mapPage', reducer });
const withSaga = injectSaga({ key: 'mapPage', saga, mode: DAEMON });

export default compose(
  withRest,
  withUser,
  withClubs,
  withLocations,
  withRoutes,
  withReducer,
  withSaga,
  withConnect,
)(MapPage);
